import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=45fc73f2&scoped=true&"
import script from "./legal.vue?vue&type=script&lang=js&"
export * from "./legal.vue?vue&type=script&lang=js&"
import style0 from "./legal.vue?vue&type=style&index=0&id=45fc73f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc73f2",
  null
  
)

export default component.exports